<template>
  <div class="h100 top-img text-white d-flex align-items-center" style="backgroundPosition:center center">
    <div class="container">
      <div class="row">
        <div class="col-md-6  d-flex justify-content-center">
          <div class="imgHide">
            <div class="img-profile"></div>
          </div>
        </div>
        <div class="col-md-6 d-flex align-items-md-center justify-content-center">
          <div class="titleHide mx-md-5">
            <div class="top-content text-center">
              <h1 class="text_effect pb-3">Hi I'm Kerry</h1>
              <h4 class="text_effect py-2">『 求知若飢，虛心若愚 』</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyHeader'
}
</script>

<style lang="scss" scoped>
</style>
